import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Drawer, DrawerHeader, DrawerContent, Sizes, ModalHeader, ModalContent, SizeGuide } from '@sainsburys-tech/bolt'
import { MeasurementIcon } from '@sainsburys-tech/bolt-icons'
import BrandSizeGuide from '../BrandSizeGuide/BrandSizeGuide'
import * as Styled from './SizeGuide.styles'

const hasBrandedSizeGuide = brand => {
  /**
   * A list of brands that have size guide image in Amplience.
   * Currently, the "brand" value can be a character name - i.e. "Disney Marvel";
   * therefore, filter only the clothing brands.
   */
  const brands = [
    'Banana Bite',
    'Clarks',
    'FatFace',
    'Frugi',
    'Jack and Jones Junior',
    'KIDS ONLY',
    'MAMALICIOUS',
    'Maidenform',
    'Shock Absorber',
    'Sloggi',
    'Vero Moda',
    'Wonderbra',
    'Brakeburn',
    'Finery',
    'Lilly and Sid',
    'Little Mistress',
    'Sosandar',
    'Triumph',
    'Turtledove London',
    'Everbelle',
    'Fred and Noah',
    'Umbro',
    'Anorak',
    'Skechers',
    'Hush Puppies',
    'Rocket Dog',
    'Superga',
    'Burgs',
    'Grass and Air',
    'Thought',
    'Simply Be',
    'Vogue Williams',
    'French Connection',
    'Oola Lingerie',
    'Four Seasons',
    'NYDJ',
    'Original Penguin',
    'Osprey London',
    'Jacamo',
    'Farah',
    'Casual Friday',
    'Hey Dude',
    'Figleaves',
    'Moda In Pelle',
    'Hummel',
    'Ilse Jacobsen',
    'Elie Beaumont',
    'Joe Browns',
    'Ben Sherman',
    'Kaffe',
    'Too Young To Be Bored',
    'Havaianas',
    'Hawes and Curtis',
    'Start-Rite',
    'JoJo Maman Bebe',
    'Blend',
    'Vila',
    'Noisy May',
    'JJ Rebel',
    'Snowdonia',
    'Weird Fish',
    'Dorothy Perkins',
    'Warehouse',
    'Oasis',
    'Wallis',
    'Faith',
    'JD Williams',
    'Speedo',
    'Burton'
  ]

  return brands.includes(brand.trim())
}

const SizeGuideWrapper = ({ categoryId, pimId, heading, brand }) => {
  const [isOpen, setOpen] = useState(false)

  const toggleSizeGuide = useCallback(() => setOpen(state => !state), [])

  return (
    <>
      <Styled.SizeGuide data-test='size-guide'>
        <a role='link' tabIndex='0' onKeyPress={toggleSizeGuide} onClick={toggleSizeGuide}>
          <span>
            <MeasurementIcon width='24px' height='24px' />
          </span>
          Size guide
        </a>
      </Styled.SizeGuide>
      {pimId ? (
        <Styled.Modal
          show={isOpen}
          onClose={() => setOpen(false)}
          size='full'
          position='center'
          data-test='component-size-guide-modal'
          isBranded={brand !== 'Tu' && hasBrandedSizeGuide(brand)}
        >
          <ModalHeader>{heading}</ModalHeader>
          <ModalContent>
            {brand !== 'Tu' && hasBrandedSizeGuide(brand) ? (
              <BrandSizeGuide brand={brand} data-test='component-brand-size-guide' />
            ) : (
              <SizeGuide categoryId={`${pimId}`} data-test='component-size-guide' />
            )}
          </ModalContent>
        </Styled.Modal>
      ) : (
        <Drawer show={isOpen} onClose={() => setOpen(false)} data-test='component-drawer-size-guide'>
          <DrawerHeader>{heading}</DrawerHeader>
          <DrawerContent>
            <Sizes id={`${categoryId}`} data-test='component-size-guide' />
          </DrawerContent>
        </Drawer>
      )}
    </>
  )
}

SizeGuideWrapper.propTypes = {
  categoryId: PropTypes.number.isRequired,
  pimId: PropTypes.string.isRequired,
  heading: PropTypes.string,
  brand: PropTypes.string.isRequired
}

SizeGuideWrapper.defaultProps = {
  heading: 'Size Guide'
}

export default SizeGuideWrapper
